module.exports = __webpack_public_path__ + "fonts/Montserrat-ThinItalic.372c7be.eot";